import { render, staticRenderFns } from "./DistributionCenterSummary.vue?vue&type=template&id=2cf86e82&scoped=true&"
import script from "./DistributionCenterSummary.vue?vue&type=script&lang=js&"
export * from "./DistributionCenterSummary.vue?vue&type=script&lang=js&"
import style0 from "./DistributionCenterSummary.vue?vue&type=style&index=0&id=2cf86e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf86e82",
  null
  
)

export default component.exports